// extracted by css-extract-rspack-plugin
export default {"SidebarAside":"ZolDa","ChildrenContainer":"oMN3y","ButtonContainer":"e0XWK"};